import {
  cardsAPI,
  categoriesAPI,
  chatyAPI,
  currentPageElementsAPI,
  ordersAPI,
} from '@hts/shared/api';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { mainReducer } from './providers';

export const rootReducer = combineReducers({
  mainReducer,

  [currentPageElementsAPI.reducerPath]: currentPageElementsAPI.reducer,
  [ordersAPI.reducerPath]: ordersAPI.reducer,
  [cardsAPI.reducerPath]: cardsAPI.reducer,
  [chatyAPI.reducerPath]: chatyAPI.reducer,
  [categoriesAPI.reducerPath]: categoriesAPI.reducer,
});

export const setupStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        currentPageElementsAPI.middleware,
        ordersAPI.middleware,
        cardsAPI.middleware,
        chatyAPI.middleware,
        categoriesAPI.middleware
      ),
    devTools: true,
  });
